/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Text,
  Heading,
  Tabs,
  Box,
  Flex,
  Button,
  AlertDialog,
} from "@radix-ui/themes";
import "./CampaignsForm.css";
import { useLocation } from "react-router-dom";
import { approveCampaign, getCampaignByID } from "../../Services/DashboardApi";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { useNavigate } from "react-router-dom";
import CampaignDetails from "../../Component/CampaignDetails";
import ComunityBox from "../../Component/ComunityBox";
import NotesBox from "../../Component/NotesBox";
import FundingBox from "../../Component/FundingBox";

const CampaignsForm = () => {
  const [campaignFee, setCampaignFee] = useState({});
  const [campaignGoals, setCampaignGoals] = useState({});
  const [companyDetails, setCompanyDetails] = useState([]);
  const [funding, setFunding] = useState({});
  const [profileAssets, setProfileAssets] = useState({});
  const [notes, setNotes] = useState("");
  const [contactDetails, setContactDetails] = useState({});
  const [resourceDetails, setResourceDetails] = useState({});
  const [resourceLocationDetails, setResourceLocationDetails] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { setloader, initAlert } = GeneralContextFunc();

  const approvalCampaign = () => {
    setloader(true);
    let payload = {
      id: location?.state?.id,
    };
    approveCampaign(payload)
      .then((res) => {
        initAlert(res?.message);
        setloader(false);
        navigate("/campaigns");
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  const getCampaignDataById = (payload) => {
    setloader(true);
    getCampaignByID(payload)
      .then((res) => {
        // Map the nested API response structure to the existing state variables
        const data = res?.data;
        
        // Map campaignFee from the nested structure
        setCampaignFee(data?.CampaignFee || {});
        
        // Map campaignGoals from the nested structure
        setCampaignGoals(data?.CampaignGoals || {});
        
        // Map companyDetails (if it exists in the new structure)
        setCompanyDetails(data?.CompanyDetails || []);
        
        // Map funding (if it exists in the new structure)
        setFunding(data?.Funding || {});
        
        // Map profileAssets from the nested structure
        setProfileAssets(data?.ProfileAssets || {});
        
        // Map notes (if it exists in the new structure)
        setNotes(data?.Notes || "");
        
        // Map contactDetails from the nested structure
        setContactDetails(data?.ContactDetails || {});
        
        // Map resourceDetails from the nested structure
        setResourceDetails(data?.ResourceDetails || {});
        
        // Map resourceLocationDetails from the nested structure
        setResourceLocationDetails(data?.ResourceLocationDetails || []);
        
        // initAlert(res?.message);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    let payload = {
      id: location.state.id,
    };
    setloader(true);
    getCampaignDataById(payload);
  }, []);
  return (
    <>
      <Flex mt="5" mx="5" justify="between">
        <Heading align="left" size="8">
          Campaign
        </Heading>
        <AlertDialog.Root>
          <AlertDialog.Trigger>
            <Button style={{ cursor: "pointer" }}>Approve</Button>
          </AlertDialog.Trigger>
          <AlertDialog.Content maxWidth="380px">
            <AlertDialog.Title>
              Are you sure You want to approve this ?
            </AlertDialog.Title>
            <Flex justify="end" gapX="4">
              <AlertDialog.Cancel>
                <Button variant="outline">No</Button>
              </AlertDialog.Cancel>
              <AlertDialog.Action>
                <Button onClick={() => approvalCampaign()}>Yes, Approve</Button>
              </AlertDialog.Action>
            </Flex>
          </AlertDialog.Content>
        </AlertDialog.Root>
      </Flex>
      <Tabs.Root defaultValue="Details" mx="5" mt="5">
        <Tabs.List
          className="headerListCampaingn"
          highContrast
          color="gray"
          size="2"
        >
          <Tabs.Trigger value="Details">
            <Flex direction="column">
              <Text
                align="left"
                weight="regular"
                color="gray"
                highContrast
                size="2"
              >
                1. Details
              </Text>
              <Text align="left" color="gray" weight="regular" size="1">
                Optional Label
              </Text>
            </Flex>
          </Tabs.Trigger>
          <Tabs.Trigger value="Community">
            <Flex direction="column">
              <Text
                align="left"
                weight="regular"
                color="gray"
                highContrast
                size="2"
              >
                2. Community Details/NO profit/Small business
              </Text>
              <Text align="left" color="gray" weight="regular" size="1">
                Optional Label
              </Text>
            </Flex>
          </Tabs.Trigger>
          <Tabs.Trigger value="Notes">
            <Flex direction="column">
              <Text
                align="left"
                weight="regular"
                color="gray"
                highContrast
                size="2"
              >
                3. Notes
              </Text>
              <Text align="left" color="gray" weight="regular" size="1">
                Optional Label
              </Text>
            </Flex>
          </Tabs.Trigger>
          <Tabs.Trigger value="Funding">
            <Flex direction="column">
              <Text
                align="left"
                weight="regular"
                color="gray"
                highContrast
                size="2"
              >
                4. Funding
              </Text>
              <Text align="left" color="gray" weight="regular" size="1">
                Optional Label
              </Text>
            </Flex>
          </Tabs.Trigger>
        </Tabs.List>

        <Box className="dataBox" pt="3" mb="7">
          <Tabs.Content className="tabContainer" value="Details">
            <CampaignDetails
              campaignFee={campaignFee}
              campaignGoals={campaignGoals}
              profileAssets={profileAssets}
              getCampaignDataById={getCampaignDataById}
            />
          </Tabs.Content>

          <Tabs.Content value="Community">
            <ComunityBox
              companyDetails={companyDetails}
              contactDetails={contactDetails}
              resourceDetails={resourceDetails}
              getCampaignDataById={getCampaignDataById}
              resourceLocationDetails={resourceLocationDetails}
            />
          </Tabs.Content>

          <Tabs.Content value="Notes">
            <NotesBox notes={notes} getCampaignDataById={getCampaignDataById} />
          </Tabs.Content>

          <Tabs.Content value="Funding">
            <FundingBox
              funding={funding}
              getCampaignDataById={getCampaignDataById}
            />
          </Tabs.Content>
        </Box>
      </Tabs.Root>
    </>
  );
};

export default CampaignsForm;
